import React, { useContext, useEffect, useRef, useState } from 'react'
import type { GetRef, InputRef, TableProps } from 'antd'
import { Button, Form, Input, Popconfirm, Table, Select, message, Spin } from 'antd'
import styles from '../index.module.less'
import { modalCodeFn } from '@/pages/fmsConfig/receiptRulesManagement/components/codeRule'
import { httpDictServTenant } from '@/services/fmsServices'
import { useNavigate, useParams } from 'react-router-dom'
import {
  planCommonControllerFindFetchType,
  planCommonControllerFindRelevanceItem,
  receiptRulesPlanMainRulesPlanDetail,
  receiptRulesPlanRulesFullPlanDetail,
  receiptRulesPlanRulesDelete,
} from '@/services/fmsConfig'

type FormInstance<T> = GetRef<typeof Form<T>>

const EditableContext = React.createContext<FormInstance<any> | null>(null)
const Option = Select.Option

const EditableRow: React.FC<any> = ({ index, ...props }) => {
  const [form] = Form.useForm()
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  )
}

interface EditableCellProps {
  title: React.ReactNode
  editable: boolean
  dataIndex: any
  type: String
  selectList: any
  record: any
  handleSave: (record: any) => void
}

const EditableCell: React.FC<React.PropsWithChildren<EditableCellProps>> = ({
  title,
  editable,
  children,
  dataIndex,
  type,
  selectList,
  record,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false)
  const inputRef = useRef<InputRef>(null)
  const form = useContext(EditableContext)!

  useEffect(() => {
    if (editing) {
      inputRef.current?.focus()
    }
  }, [editing])

  const toggleEdit = () => {
    setEditing(!editing)
    form.validateFields()
    form.setFieldsValue({ [dataIndex]: record[dataIndex] })
  }

  const save = async () => {
    try {
      const values = await form.validateFields()
      if (values.fetchName) {
        const fetchType = selectList.find(n => values.fetchName === n.desc)
        record['fetchType'] = fetchType.code
      }
      toggleEdit()
      handleSave({ ...record, ...values })
    } catch (errInfo: any) {
      console.log('Save failed:', errInfo)
      let fetchName = errInfo.values?.fetchName
      if (fetchName) {
        const fetchType = selectList.find(n => fetchName === n.desc)
        record['fetchType'] = fetchType.code
      }
      handleSave({ ...record, ...errInfo.values })
    }
  }
  const changeSave = async () => {
    try {
      const values = await form.validateFields()
      if (values.fetchName) {
        record['fetchRulesName'] = ''
        record['fetchRules'] = ''
      }
      toggleEdit()
      handleSave({ ...record, ...values })
    } catch (errInfo: any) {
      console.log('Save failed:', errInfo)
      let fetchName = errInfo.values?.fetchName
      if (fetchName) {
        record['fetchRulesName'] = ''
        record['fetchRules'] = ''
      }
      handleSave({ ...record, ...errInfo.values })
    }
  }
  const openEditRule = () => {
    if (record['fetchName'] === '') {
      message.error('请先选择取数类型')
      toggleEdit()
      return false
    }
    modalCodeFn({
      fn: async (data: any) => {
        // 设置取数规则的值
        form.setFieldsValue({ [dataIndex]: data.code.join(' ') })
        console.log('submit', data.code, data.code.join(' '))
        record[dataIndex] = data.desc.join(' ')
        record['fetchRules'] = data.code.join(' ')
        toggleEdit()
        handleSave({ ...record, ...form.getFieldsValue() })
      },
      ...{
        code: record['fetchRules'],
        desc: record['fetchRulesName'],
        fetchTypeCode: record['fetchType'],
      },
    })
  }
  let childNode = children
  if (editable) {
    childNode = editing ? (
      type === 'text' ? (
        <Form.Item
          style={{ margin: 0 }}
          name={dataIndex}
          rules={[{ required: true, message: `请输入${title}` }]}
        >
          <Input
            // disabled={record?.appoint}
            placeholder={`请输入${title}`}
            ref={inputRef}
            onPressEnter={save}
            onBlur={save}
            onFocus={openEditRule}
          />
        </Form.Item>
      ) : (
        <Form.Item
          style={{ margin: 0 }}
          name={dataIndex}
          rules={[{ required: true, message: `请选择${title}` }]}
        >
          <Select
            // disabled={record?.appoint}
            placeholder={`请选择${title}`}
            style={{ width: '100%', margin: '-5px 0' }}
            onBlur={save}
            onChange={changeSave}
          >
            {selectList &&
              selectList.map((item, index) => {
                return (
                  <Option key={index} value={item.desc ? item.desc : item.name}>
                    {item.desc ? item.desc : item.name}
                  </Option>
                )
              })}
          </Select>
        </Form.Item>
      )
    ) : (
      <div
        className={styles.editableCellValueWrap}
        style={{ paddingInlineEnd: 24 }}
        onClick={toggleEdit}
      >
        {children}
      </div>
    )
  }

  return <td {...restProps}>{childNode}</td>
}

interface DataType {
  key: React.Key
  name: string
  age: string
  address: string
}

type ColumnTypes = Exclude<TableProps<DataType>['columns'], undefined>

// 修改组件接口定义`
interface Props {
  onDataChange?: () => void
}

export default ({ onDataChange }: Props) => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [dataSource, setDataSource] = useState<any[]>([])
  const [count, setCount] = useState(0)
  const [loading, setLoading] = useState(false)
  const [spinning, setSpinning] = useState(false)
  const [isDisabled, setIsDisabled] = useState(false)
  const [paymentTypeList, setPaymentTypeList] = useState([] as any)
  const [fetchTypeList, setFetchTypeList] = useState([] as any)
  const [relevanceItemList, setRelevanceItemList] = useState([] as any)
  useEffect(() => {
    getStatusOptions()
    getRulesPlanDetail()
  }, [])
  const getRulesPlanDetail = () => {
    setSpinning(true)
    receiptRulesPlanMainRulesPlanDetail({
      rulesPlanMainId: id,
      isFull: true,
    })
      .then(res => {
        res.rulesFullPlanDetailVo.forEach(m => {
          m.paymentName = m.paymentTypeName
          m.fetchName = m.fetchTypeName
          m.key = m.id
          // 删除多余的属性    需要变更需要传id了，哈哈哈，改3次了
          // delete m.id;
          // delete m.createdBy;
          // delete m.createdTime;
          // delete m.lastUpdatedTime;
          // delete m.modifiedBy;
          // delete m.tenantId;
          // delete m.rulesFullPlanId;
          // delete m.fetchGroupKey;
        })
        setDataSource(res.rulesFullPlanDetailVo)
        setSpinning(false)
      })
      .catch(err => {
        setSpinning(false)
      })
  }
  const getStatusOptions = async () => {
    let paymentType = await httpDictServTenant({ parentKey: 'receiptType', enabled: 1 })
    let fetchType = await planCommonControllerFindFetchType()
    let relevanceItem = await planCommonControllerFindRelevanceItem()
    setPaymentTypeList(paymentType)
    setFetchTypeList(fetchType)
    setRelevanceItemList(relevanceItem)
  }
  const handleDelete = record => {
    if (record.id) {
      receiptRulesPlanRulesDelete(record.id).then((res: any) => {
        message.success('删除成功')
        const newData = dataSource.filter(item => item.key !== record.key)
        setDataSource(newData)
        onDataChange?.() // 添加回调
      })
    } else {
      const newData = dataSource.filter(item => item.key !== record.key)
      setDataSource(newData)
      onDataChange?.() // 添加回调
    }
  }

  const defaultColumns: any = [
    {
      title: '应收关联事项',
      dataIndex: 'receTermName',
      type: 'select',
      selectList: relevanceItemList,
      width: 200,
      editable: true,
    },
    {
      title: '收款类型',
      dataIndex: 'paymentName',
      type: 'select',
      selectList: paymentTypeList,
      width: 180,
      editable: true,
    },
    {
      title: '取数类型',
      dataIndex: 'fetchName',
      type: 'select',
      selectList: fetchTypeList,
      width: 180,
      editable: true,
    },
    {
      title: '取数类型',
      dataIndex: 'fetchType',
      width: 180,
      hidden: true,
    },
    {
      title: '取数规则',
      dataIndex: 'fetchRulesName',
      type: 'text',
      editable: true,
    },
    {
      title: '操作',
      dataIndex: 'operation',
      width: 100,
      render: (_, record) =>
        dataSource.length >= 1 ? (
          <Popconfirm title="是否删除?" onConfirm={() => handleDelete(record)}>
            <Button color="danger" variant="link" disabled={record?.appoint}>
              删除
            </Button>
          </Popconfirm>
        ) : null,
    },
  ]

  const handleAdd = () => {
    const newData: any = {
      key: count,
      receTermType: '',
      receTermName: '',
      paymentType: '',
      paymentName: '',
      fetchType: '',
      fetchName: '',
      fetchRules: '',
      fetchRulesName: '',
    }
    setDataSource([...dataSource, newData])
    setCount(count + 1)
    onDataChange?.() // 添加回调
  }

  const handleSave = (row: DataType) => {
    const newData = [...dataSource]
    const index = newData.findIndex(item => row.key === item.key)
    const item = newData[index]
    newData.splice(index, 1, {
      ...item,
      ...row,
    })
    setDataSource(newData)
    onDataChange?.() // 添加回调
  }
  const onSave = () => {
    for (let m of dataSource) {
      const relevanceItem = relevanceItemList.find(n => m.receTermName === n.desc)
      const paymentType = paymentTypeList.find(n => m.paymentName === n.name)
      const fetchType = fetchTypeList.find(n => m.fetchName === n.desc)
      if (relevanceItem) {
        m.receTermType = relevanceItem.code
      }
      if (paymentType) {
        m.paymentType = paymentType.priKey
      }
      if (fetchType) {
        m.fetchType = fetchType.code
      }
      m.planMainId = id
    }
    setLoading(true)
    receiptRulesPlanRulesFullPlanDetail(dataSource)
      .then(res => {
        message.success(res.message || '操作成功')
        setLoading(false)
        // 保存成功后重置未保存状态
        onDataChange?.(false) // 可以传入false表示数据已保存
      })
      .catch(() => {
        setLoading(false)
      })
  }
  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  }

  const columns = defaultColumns.map(col => {
    if (!col.editable) {
      return col
    }
    return {
      ...col,
      onCell: (record: DataType) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        type: col.type,
        selectList: col.selectList,
        handleSave,
      }),
    }
  })
  useEffect(() => {
    let bol = dataSource.some(
      item => !item.receTermName || !item.paymentName || !item.fetchName || !item.fetchRulesName
    )
    setIsDisabled(bol)
  }, [dataSource])
  return (
    <Spin spinning={spinning}>
      <div style={{ marginTop: 15 }}>
        <div style={{ display: 'flex', justifyContent: 'end' }}>
          <Button onClick={handleAdd} type="primary" style={{ marginBottom: 15 }}>
            新增
          </Button>
        </div>
        <Table
          size="small"
          components={components}
          rowClassName={() => styles.editableRow}
          bordered
          dataSource={dataSource}
          columns={columns as ColumnTypes}
          pagination={false}
        />
        <div style={{ display: 'flex', justifyContent: 'end' }}>
          <Button
            onClick={onSave}
            disabled={isDisabled}
            loading={loading}
            type="primary"
            style={{ marginTop: 15 }}
          >
            保存
          </Button>
        </div>
      </div>
    </Spin>
  )
}
